import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbarConnectedNoInternet26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.846c4.468 0 7.446 2.437 7.748 2.659l-.831 1.033h-2.61v3.25l-4.3 5.36-.007.006-.006-.012L.258 4.505C.554 4.283 3.532 1.846 8 1.846m6.77 11.077v1.23h-1.232v-1.23zm0-6.154v4.923h-1.232V6.77z"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbarConnectedNoInternet26X24Px
